import type { ReactNode } from 'react';

import { Flex } from '@spotify-internal/encore-web';
import { AuthScreen } from '@spotify/confidence-core-react';

import styles from './OnboardingStepLayout.module.css';

type OnboardingStepLayoutProps = {
  title: ReactNode;
  headerSize?: 'large' | 'compact';
  description?: ReactNode;
  progress?: ReactNode;
  trackId: string;
  children: ReactNode;
};

export const OnboardingStepLayout = ({
  title,
  headerSize = 'large',
  description,
  progress,
  trackId,
  children,
}: OnboardingStepLayoutProps) => (
  <AuthScreen.Root>
    <AuthScreen.Main className={styles.main}>
      <Flex
        direction="column"
        gap="looser"
        className={styles.layout}
        data-track-scope={trackId}
        data-track-id={trackId}
        data-track-impression
      >
        <Flex
          direction="column"
          gap={headerSize === 'large' ? 'looser' : 'base'}
          className={styles.header}
        >
          {progress}
          <AuthScreen.Title
            variant={headerSize === 'large' ? 'titleLarge' : 'titleMedium'}
          >
            {title}
          </AuthScreen.Title>
          {description && (
            <AuthScreen.Description>{description}</AuthScreen.Description>
          )}
        </Flex>
        <AuthScreen.Card>{children}</AuthScreen.Card>
      </Flex>
    </AuthScreen.Main>
  </AuthScreen.Root>
);
